import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import {
  REFERRAL_LOCIZE,
  HOW_TO_EARN_LIST,
} from 'components/referral/landing/const'
import styles from './styles.scss'

const ReferralHowToEarn = ({
  internationalization: { country, language },
  t,
}) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <div className="referral-how-to-earn">
      <div className="referral-how-to-earn__wrapper">
        <span className={clsx('referral-how-to-earn__title', Typo.title3)}>
          {hasLocizeTranslation(
            t,
            REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_TITLE.key,
            REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_TITLE.text,
          )}
        </span>
        {HOW_TO_EARN_LIST.map((item, index) => (
          <div className="referral-how-to-earn__list" key={index}>
            <Icon src={item.icon} size={item.iconSize} />
            <span className={clsx('referral-how-to-earn__detail', Typo.body2)}>
              {hasLocizeTranslation(t, item.key, item.text)}
            </span>
          </div>
        ))}
        <Button
          className="referral-how-to-earn__perks-cta"
          type={BUTTON_TYPES.link}
          link
          aProps={{
            href: `/${country}/${language}/loyalty-program`,
            rel: 'noopener',
          }}
          target="_blank"
        >
          {hasLocizeTranslation(
            t,
            REFERRAL_LOCIZE.REFERRAL_LEARN_MORE.key,
            REFERRAL_LOCIZE.REFERRAL_LEARN_MORE.text,
          )}
        </Button>
      </div>
    </div>
  </React.Fragment>
)

ReferralHowToEarn.propTypes = {
  internationalization: PropTypes.shape({
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(ReferralHowToEarn)

export default connect((state) => ({
  internationalization: state.internationalization,
}))(Extended)
